/* eslint-disable import/prefer-default-export */
/**
 * Convert custom markup to HTML
 * @param {string} input - String to convert into markup
 */
export const customMarkup = input => (input?.replace(/\[\/[biu]{1}\]/g, '</span>')
    .replace(/\[b\]/g, '<span class="markup--bold">')
    .replace(/\[i\]/g, '<span class="markup--italic">')
    .replace(/\[u\]/g, '<span class="markup--underline">'));
